module.exports = __webpack_public_path__ + "static/img/SmileAnimation_raspberry.3dc242e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_raspberry.gif
// module id = p4Pe
// module chunks = 0